import { localStorage } from '@/util/chrome.api'
import { saveState, delState } from '@/util/localstorage'
import { githubProxyHost } from '@/config/'

import Http from '@/util/http'

export default {
  state: {
    accessToken: '',
    user: window.localStorage.getItem('user') ? JSON.parse(window.localStorage.getItem('user')) : null,
  },
  mutations: {
    login(state, user) {
      state.user = user
      state.user.avatarProxy = user.avatar.replace(/^(https:\/\/.*)(\/u\/.*)$/, `${githubProxyHost}avatar$2`)
      saveState('user', JSON.stringify(user))
      this.commit('event/initHotkey', state.user.hotkeys && state.user.hotkeys.web)
    },
    setUserData(state, user) {
      console.log(user)
      user.refreshToken = state.user.refreshToken
      user.avatarProxy = user.avatar.replace(/^(https:\/\/.*)(\/u\/.*)$/, `${githubProxyHost}avatar$2`)
      state.user = user
      this.commit('event/initHotkey', state.user.hotkeys && state.user.hotkeys.web)
      saveState('user', JSON.stringify(user))
    },
    logOut(state) {
      state.user = null
      delState('user')
      // window.localStorage.removeItem('user')
    },
    /**
     * 初始化用户数据
     */
    initUserData(state, type) {
      return new Promise((resolve, reject) => {
        if (type === 'content') {
          localStorage({ type: 'getLocalStorage', key: 'user' }).then((user) => {
            state.user = user
            resolve()
          }).catch((err) => {
            reject(err)
          })
        } else {
          state.user = window.localStorage.getItem('user')
          resolve()
        }
      })
    },
    setAutoBackup(state, value) {
      state.user.autoBackup = value
      saveState('user', JSON.stringify(state.user))
    },
    setAccessToken(state, token) {
      const user = this.state.user.user

      if (!user) return

      // const octokit = githubApi(user.github.login, user.github.token)

      // octokit.apps.checkToken({
      //   client_id: Github.clientId,
      //   access_token: token,
      // }).then((res) => {
      //   console.log(res)
      // }).catch((err) => {
      //   if (err) { console.log(err) }
      // })
      state.accessToken = token
      window.localStorage.setItem('accessToken_' + this.state.user.user.id, token)
    },
    async getAccessToken(state) {
      let token = window.localStorage.getItem('accessToken_' + this.state.user.user.id)
      if (!token) {
        token = await localStorage({ type: 'getLocalStorage', key: 'accessToken_' + this.state.user.user.id })
        if (token) window.localStorage.setItem('accessToken_' + this.state.user.user.id, token || '')
      }
      state.accessToken = token
    },
  },
  actions: {
    /**
     * 获取最新的用户信息
     * @param {*} param0
     */
    updateUserInfo({ commit }) {
      const http = this._vm.$http
      return http.get('/user').then((res) => {
        if (res.user) {
          commit('setUserData', res.user)
          // 获取token
          commit('getAccessToken')
          return res.user
        } else {
          return Promise.reject()
        }
      }).catch((err) => {
        return Promise.reject(err)
      })
    },
    getUserInfo({ commit }) {
      // 从本地拿用户信息
      // 从新拉取一遍最新的信息
      // 先从插件拿user，如果没有user再从本地拿
      return new Promise((resolve, reject) => {
        localStorage({ type: 'getLocalStorage', key: 'user' }).then((user) => {
          if (user && user.github) {
            resolve(user)
            commit('login', user)
            // 获取token
            commit('getAccessToken')
          } else {
            const localUser = window.localStorage.getItem('user') ? JSON.parse(window.localStorage.getItem('user')) : null

            if (!localUser) {
              reject()
            } else {
              resolve(localUser)
              commit('login', localUser)
              // 获取token
              commit('getAccessToken')
            }
          }
        }).catch(() => {
          const localUser = window.localStorage.getItem('user') ? JSON.parse(window.localStorage.getItem('user')) : null

          if (!localUser) {
            reject()
          } else {
            resolve(localUser)
            commit('login', localUser)
            // 获取token
            commit('getAccessToken')
          }
        })
      })
    },
    logOut({ commit }) {
      const req = this._vm.$http || Http
      return req.get('/auth/logout').then(() => {
        commit('logOut')
      }).catch(() => {
        commit('logOut')
      })
    },
  },
  namespaced: true,
}
